import { render, staticRenderFns } from "./AdditionalDeals.vue?vue&type=template&id=6b8872d5&scoped=true"
import script from "./AdditionalDeals.vue?vue&type=script&lang=js"
export * from "./AdditionalDeals.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDeals.vue?vue&type=style&index=0&id=6b8872d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8872d5",
  null
  
)

export default component.exports